import authService from './auth';

export class BaseService {
    refreshTokenFromResponse(response) {
        if (response && (response.status === 401 || response.status === 403)) {
            authService.handleSessionExpired();
            return;
        }
        if (!response || !response.headers || !response.headers["overwatch-token"]) {
            return;
        }
        localStorage.setItem( "overwatch-token", response.headers["overwatch-token"] );
    }
}